exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".tb-users{width:100%;border-collapse:collapse}.tb-users thead th{text-align:left;padding:5px}.tb-users tbody td{padding:5px}.tb-users thead tr{border-bottom:1px solid #999}.tb-users tbody tr{border-bottom:1px solid #ddd}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/painel/conta/usuarios.vue"],"names":[],"mappings":"AACA,UAAU,WAAY,AAAC,wBAA0B,CAChD,AACD,mBAAmB,gBAAgB,WAAY,CAC9C,AACD,mBAAmB,WAAY,CAC9B,AACD,mBAAmB,4BAA6B,CAC/C,AACD,mBAAmB,4BAA6B,CAC/C","file":"usuarios.vue","sourcesContent":["\n.tb-users{width: 100%; border-collapse: collapse;\n}\n.tb-users thead th{text-align:left;padding:5px;\n}\n.tb-users tbody td{padding:5px;\n}\n.tb-users thead tr{border-bottom: 1px solid #999\n}\n.tb-users tbody tr{border-bottom: 1px solid #ddd\n}\r\n\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f9c978fa","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/painel/conta/usuarios.vue
// module id = 644
// module chunks = 10